<template>
    <div v-loading.fullscreen.lock="loading" class="content container">
        <br/>
        <div style="text-align: left">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="udid">
                    <el-input ></el-input>
                </el-form-item>
                <el-form-item label="安全码">
                    <el-input ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search">搜索</el-button>
                </el-form-item>
                <el-button @click="createSecurityCode" type="primary">生成安全码</el-button>
            <el-button @click="exportExcel" type="success">导出Excel</el-button>
            </el-form>
        </div>
        <el-table :data="appDownloadCodes" border>
            <el-table-column prop="securityCode" label="安全码"></el-table-column>
            <el-table-column prop="udid" label="设备id" sortable></el-table-column>
            <el-table-column :formatter="vueFormatDateTime" prop="createTime" label="创建时间" sortable></el-table-column>
            <el-table-column fixed="right" label="操作" width="80">
                <template slot-scope="scope">
                    <el-button @click.native.prevent="deleteAppDownloadCode(scope.$index,appDownloadCodes)" type="danger" icon="el-icon-delete" circle></el-button>
                </template>
            </el-table-column>
        </el-table>
        <download-excel ref="downloadExcel" class="export-excel-wrapper" :data="appDownloadCodes" :fields="excel_fields" :name="app.appName+'安全码.xls'">&nbsp;</download-excel>
    </div>
    
</template>
<script>
import JsonExcel from 'vue-json-excel'
export default {
    components: {
      'downloadExcel': JsonExcel
    },  
    mounted() {
        var shortLink = this.$route.params.shortLink;
        this.$http.post(this._Global.HTTP_SERVER + "/auth/app/info", {link: shortLink,authToken: this.getToken()})
            .then(response => {
                this.respDataHandle(response.body, (respData)=> {
                    this.app = respData;
                    this.$emit("setApp", respData)
                    this.search()
                });
            });
    },
    data() {
        return {
            app:null,
            securityCode:null,
            udid:null,
            appDownloadCodes:[],
            loading:false,
            excel_fields:{
                '应用id': {
                    field: 'appId',
                    callback: (value)=> {
                    return String(value);
                    }
                },
                'udid': 'udid',
                'securityCode': 'securityCode',
                '创建时间': {
                    field: 'createTime',
                    callback: (value)=> {
                    return this.formatDateTime(value)
                    }
                },
            },
        }
    },
    methods: {
        search:function () {
            var params={}
            params.udid=this.udid
            params.appId=this.app.id
            params.securityCode=this.securityCode
            params.authToken=this.getToken()
            this.$http.post(this._Global.HTTP_SERVER+"/auth/app/download/code/search",params).then(response=>{
                this.respDataHandle(response.data,(data)=>{
                    this.appDownloadCodes=data
                })
            })
        },
        createSecurityCode:function () {
            this.$prompt('请输入生成个数（每次最大输入1000）', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /(^[1-9]\d{0,2}|1000)$/,
                inputErrorMessage: '格式不正确'
            }).then(({ value }) => {
                this.loading=true
                this.$http.post(this._Global.HTTP_SERVER+"/auth/app/download/code/create",{authToken:this.getToken(),num:value,appId:this.app.id}).then(response=>{
                    this.respDataHandle(response.body,(data)=>{
                        this.loading=false
                        if (data) {
                            this.$message({
                                message: '下载码创建成功',
                                type: 'success'
                            });
                            this.search()
                        }
                    })
                })
            })
        },
        exportExcel:function () {
            var params={}
            params.udid=""
            params.appId=this.app.id
            params.securityCode=""
            params.authToken=this.getToken()
            this.$http.post(this._Global.HTTP_SERVER+"/auth/app/download/code/search",params).then(response=>{
                this.respDataHandle(response.data,(data)=>{
                    if(data.length==0){
                        this.$message({
                            message: '数据为空',
                            type: 'warning'
                        });
                        return
                    }
                    this.$refs.downloadExcel.data=data
                    this.$refs.downloadExcel.generate()
                })
            })
        },
        deleteAppDownloadCode:function (index,datas) {
            var id=datas[index].id
            this.$http.post(this._Global.HTTP_SERVER+"/auth/app/download/code/delete",{authToken:this.getToken(),id:id,appId:this.app.id}).then(response=>{
                this.respDataHandle(response.body,(data)=>{
                    if(data){
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        })
                        this.appDownloadCodes.splice(index,1)
                    }else{
                        this.$message.error('删除失败');
                    }
                })
            })
        }
    },
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/AppDownloadCode.vue